import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable({ providedIn: 'root' })
export class TokenClaimsService {
  constructor(private readonly keycloak: KeycloakService) {}

  async getFieldValueFromKey(key: string): Promise<any> {
    if (globalThis.window === undefined || typeof sessionStorage === 'undefined') {
      return undefined;
    }

    const flutterToken =
      sessionStorage.getItem('flutter_token') ||
      sessionStorage.getItem('auth_token') ||
      localStorage.getItem('flutter_token');

    //  Se tiver token do Flutter, decodificar dele
    if (flutterToken) {
      try {
        const parts = flutterToken.split('.');

        if (parts.length > 1) {
          const base64Url = parts[1];
          let base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
          while (base64.length % 4) {
            base64 += '=';
          }

          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split('')
              .map((c) => '%' + ('00' + c.codePointAt(0)!.toString(16)).slice(-2))
              .join(''),
          );

          const payload = JSON.parse(jsonPayload);

          return payload?.[key];
        }
      } catch (e) {
        console.error(' Erro ao decodificar token Flutter:', e);
      }
    }
    // 2. Fluxo normal Keycloak
    try {
      const logged = this.keycloak.isLoggedIn();
      if (logged) {
        const tokenParsed = this.keycloak.getKeycloakInstance().tokenParsed;
        return tokenParsed?.[key];
      }
    } catch (e) {
      console.error('Erro ao verificar login do Keycloak no getFieldValueFromKey:', e);
    }
    return undefined;
  }
}
